export default __webpack_public_path__ + "cfc8fad.png";